import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import IntToEnglish from "../../../IntToEnglish/IntToEnglish";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditCashDeposit({
  open,
  onClose,
  user,
  master,
  reload,
}) {
  const [newCashDeposit, setNewCashDeposit] = useState(user?.deposit ?? "");
  const [newInterestRate, setNewInterestRate] = useState(
    user?.interest_rate ?? ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const min_interest_rate = Number(master?.deposit_interest_rate ?? 0);

  const handleSave = useCallback(
    async (action) => {
      if (!newCashDeposit.trim()) {
        toast.error("Cash Deposit cannot be empty");
        return;
      }
      if (!newInterestRate.trim()) {
        toast.error("Deposit Interest cannot be empty");
        return;
      }

      if (newInterestRate < min_interest_rate) {
        toast.error(`Min: ${min_interest_rate}%`);
        return;
      }

      setIsLoading(true);
      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        user_id: user.id,
        token: localStorage.getItem("token"),
        username: localStorage.getItem("username"),
        deposit: action === "ADD" ? newCashDeposit : -newCashDeposit,
        interest_rate: newInterestRate,
      };

      try {
        const response = await backend.edit_user_deposit(payload);
        if (response.error === "False") {
          toast.success(response.message);
          onClose();
          reload();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error("Network Error — try again.");
      } finally {
        setIsLoading(false);
      }
    },
    [newCashDeposit, newInterestRate, user]
  );

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div
        className={`rounded-xl shadow-lg w-[90%] border-2 border-[var(--hover)] max-w-md p-6 transition bg-[var(--background)] `}
      >
        {/* Header */}
        <h2 className="text-lg font-bold text-[var(--text)]">
          💰 Edit User Cash Deposit
        </h2>

        {/* Cash input */}
        <input
          type="number"
          disabled={isLoading}
          value={newCashDeposit}
          onChange={(e) => setNewCashDeposit(e.target.value)}
          className="mt-4 w-full bg-[var(--background)] text-[var(--text)] border-1 border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder="Enter User Cash Deposit"
          onKeyDown={(e) => e.key === "Enter" && handleSave("add")}
        />

        {newCashDeposit && (
          <h2 className="mt-2 text-sm text-[var(--text)] font-medium">
            <IntToEnglish total={newCashDeposit.replace(/[^0-9]/g, "")} />
          </h2>
        )}

        {/* Interest */}
        <h2 className="text-lg font-bold mt-5 text-[var(--text)]">
          📈 Deposit Interest (%)
        </h2>
        <input
          type="number"
          disabled={isLoading}
          value={newInterestRate}
          onChange={(e) => setNewInterestRate(e.target.value)}
          className="mt-4 w-full bg-[var(--background)] text-[var(--text)] border-1 border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder="Enter Interest Rate"
          onKeyDown={(e) => e.key === "Enter" && handleSave("add")}
        />

            <div className="p-2 text-sm font-semibold text-[var(--text)]">
          Min Interest : {min_interest_rate}%
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--sell)] text-white"
          >
            Cancel
          </button>

          <button
            onClick={() => handleSave("REMOVE")}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--sell)] text-white"
          >
            {isLoading ? "Processing…" : "Remove"}
          </button>

          <button
            onClick={() => handleSave("ADD")}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--buy)] text-white"
          >
            {isLoading ? "Processing…" : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
}
